module.exports = __webpack_public_path__ + "img/program1.32af07d0.png";